var UA = require('../internals/engine-user-agent');

module.exports = /MSIE|Trident/.test(UA);



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/engine-is-ie-or-edge.js